import LegalLayout from "./LegalLayout";

export default function TermsHr() {
  return (
    <LegalLayout
      testId="terms-hr-page"
      eyebrow="Pravno"
      title="Opći uvjeti poslovanja"
      updated="Veljača 2026."
    >
      <section>
        <h2>1. O tvrtki Juke Transfers</h2>
        <p>
          Ovi Opći uvjeti poslovanja (&bdquo;Uvjeti&ldquo;) uređuju usluge prijevoza, chauffeur usluge i
          povezane usluge koje pruža <strong>JUKE TRANSFERS j.d.o.o.</strong> (OIB: 05308456115),
          hrvatsko trgovačko društvo s ograničenom odgovornošću sa sjedištem u Splitu, Hrvatska
          (&bdquo;Juke Transfers&ldquo;, &bdquo;mi&ldquo;, &bdquo;nas&ldquo;). Rezervacijom usluge kod nas prihvaćate ove Uvjete.
        </p>
        <p>
          <strong>Model rezervacije.</strong> Juke Transfers posluje istodobno kao izravni pružatelj
          prijevoznih usluga i kao online platforma za rezervacije / agent. Ovisno o opciji plaćanja
          odabranoj na naplati, klijent će:
        </p>
        <ol>
          <li>
            Platiti <strong>20% nepovratnog predujma</strong> (Rezervacijska naknada) online tvrtki
            Juke Transfers j.d.o.o., pri čemu se preostalih <strong>80% podmiruje u gotovini
            izravno vozaču</strong> u vozilu; ili
          </li>
          <li>
            Platiti <strong>100% ukupnog iznosa online</strong> gdje je primjenjivo.
          </li>
        </ol>
        <p>
          Kada transfer u naše ime obavlja partner-vozač, Juke Transfers djeluje kao posrednik
          između klijenta i vozača. 20% predujam pokriva rezervaciju, koordinaciju i uslugu platforme
          te je nepovratan osim kada zakon propisuje drugačije.
        </p>
      </section>

      <section>
        <h2>2. Rezervacije i potvrde</h2>
        <p>
          Rezervacija postaje obvezujuća tek nakon što pošaljemo pisanu potvrdu (e-mail ili
          WhatsApp) s brojem reference, podacima o preuzimanju i cijenom. Ponude generirane na
          web stranici su procjene dok ih naš tim ne potvrdi. Klijent je odgovoran za točnost
          adrese preuzimanja, adrese dostave, datuma, vremena, broja putnika, prtljage i broja
          leta u trenutku rezervacije.
        </p>
      </section>

      <section>
        <h2>3. Cijene</h2>
        <ul>
          <li>Sve cijene su u eurima (&euro;) i uključuju primjenjive hrvatske poreze.</li>
          <li>Fiksne rute su transparentno objavljene. Prijevozi po kilometraži izračunavaju se
              po kilometru s početnom naknadom.</li>
          <li>Noćna nadoplata od +20% primjenjuje se za preuzimanja između 22:00 i 06:00 po
              lokalnom vremenu.</li>
          <li>Naknade za kovčege, vrijeme čekanja i potvrđene dodatke (piće, grickalice, SIM
              kartica) uključene su u konačnu cijenu prikazanu klijentu.</li>
        </ul>
      </section>

      <section>
        <h2>4. Kašnjenje leta i vrijeme čekanja</h2>
        <p>
          Prijevozi sa zračne luke uključuju automatsko praćenje letova. Kada je pri rezervaciji
          naveden valjan broj leta, dolazak vozača usklađuje se sa
          <strong> stvarnim vremenom slijetanja</strong>, a ne s izvorno planiranim vremenom.
        </p>
        <ul>
          <li>
            <strong>Besplatno vrijeme čekanja:</strong> prvih <strong>60 minuta</strong> čekanja
            nakon stvarnog vremena slijetanja je besplatno. Ovo pokriva graničnu kontrolu,
            preuzimanje prtljage i razumna kašnjenja do mjesta susreta.
          </li>
          <li>
            <strong>Dodatno vrijeme čekanja:</strong> svako vrijeme čekanja uzrokovano kašnjenjem
            klijenta izvan besplatnog razdoblja (npr. kasni dolazak na mjesto susreta, nenajavljene
            promjene rasporeda, produženi zaustavljanja) naplaćuje se po
            <strong> fiksnoj satnici od &euro;25 / sat</strong>, u intervalima od 30 minuta.
          </li>
          <li>
            Za preuzimanja izvan zračne luke primjenjuje se razdoblje tolerancije od
            <strong> 15 minuta</strong> od potvrđenog vremena; nakon toga vrijedi ista stopa
            od &euro;25 / sat.
          </li>
          <li>
            Ako je let preusmjeren, otkazan ili pomaknut na drugi dan, poduzet ćemo sve razumne
            napore da preraspoređivanje bude bez dodatnih troškova. Dodatna dispečerska
            organizacija izvan naše kontrole može biti ponovno kalkulirana.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Odgovornosti klijenta</h2>
        <ul>
          <li>Pružiti točne kontakt podatke (telefon dostupan na dan vožnje) i mjesto
              preuzimanja, uključujući ime hotela / vile i, kad je moguće, prikačenu lokaciju
              na karti.</li>
          <li>Biti na dogovorenom mjestu na vrijeme. Za dolaske sa zračne luke, vozač će čekati
              u dolaznom terminalu s pločom na kojoj piše ime.</li>
          <li>Ponašati se s poštovanjem prema vozaču, vozilu i drugim putnicima. Zadržavamo
              pravo odbiti ili prekinuti uslugu u slučajevima nedoličnog ponašanja, nezakonitog
              ponašanja ili opijenosti koji ugrožavaju sigurnost, bez povrata novca.</li>
          <li>Svaka šteta koju putnik nanese vozilu (razlivanja hrane/pića koje nismo pružili
              mi, povraćanje, opekline od cigareta, fizička oštećenja) naplatit će se po
              standardnoj tarifi čišćenja / popravka.</li>
        </ul>
      </section>

      <section>
        <h2>6. Prtljaga</h2>
        <p>
          Kapacitet prtljage vozila naveden je na stranici voznog parka i pri rezervaciji.
          Dodatni kovčezi izvan potvrđenog broja mogu biti odbijeni prema procjeni vozača ako
          prelaze sigurnu nosivost vozila. Molimo da najavite predimenzionirane predmete
          (bicikli, skije, daske za surfanje) pri rezervaciji.
        </p>
      </section>

      <section>
        <h2>7. Odgovornost</h2>
        <p>
          Juke Transfers upravlja potpuno licenciranom i osiguranom flotom putničkih vozila u
          skladu s hrvatskim zakonima. Naša odgovornost ograničena je na cijenu plaćenu za
          rezerviranu uslugu. Ne odgovaramo za neizravne štete uzrokovane višom silom
          (vremenske prilike, zatvaranja cesta, štrajkovi, propuštene veze koje nismo mi
          uzrokovali).
        </p>
      </section>

      <section>
        <h2>8. Otkazivanja i povrat novca</h2>
        <p>
          Otkazivanja, povrati i nedolasci uređeni su našim odvojenim{" "}
          <a href="/hr/refund-policy" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">Pravilnikom o otkazivanju i povratu novca</a>.
        </p>
      </section>

      <section>
        <h2>9. Zaštita podataka</h2>
        <p>
          Osobni podaci prikupljeni tijekom postupka rezervacije obrađuju se u skladu s našom{" "}
          <a href="/hr/privacy" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">Politikom privatnosti</a>
          {" "}i EU Općom uredbom o zaštiti podataka (GDPR).
        </p>
      </section>

      <section>
        <h2>10. Mjerodavno pravo</h2>
        <p>
          Ovi Uvjeti uređeni su zakonima Republike Hrvatske. Svi sporovi bit će podvrgnuti
          isključivoj nadležnosti nadležnog suda u Splitu, Hrvatska.
        </p>
      </section>

      <section>
        <h2>11. Kontakt</h2>
        <p>
          Pitanja o ovim Uvjetima možete poslati na{" "}
          <a href="mailto:bookings@juketransfers.hr" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">bookings@juketransfers.hr</a>.
        </p>
      </section>
    </LegalLayout>
  );
}
